import styled from "styled-components";
import AliceCarousel from 'react-alice-carousel';


export const StyledCarousel = styled(AliceCarousel)`
  height: 800px !important;
  @media (max-width: 500px){
    height: fit-content;
  }
`